import { Button, ButtonProps } from "./button";
import { SortDirection } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
export const SortingButton = ({
  sort,
  onClick,
  children,
  ...props
}: Omit<ButtonProps, "variant"> & { sort: SortDirection | false } & {
  onClick: (direction: SortDirection) => void;
}) => {
  function innerOnClick() {
    switch (sort) {
      case "asc": {
        onClick("desc");
        return;
      }
      case "desc": {
        onClick("asc");
        return;
      }
      case false: {
        onClick("asc");
        return;
      }
    }
  }

  return (
    <Button
      variant="ghost"
      type="button"
      onClick={innerOnClick}
      {...props}
      className="p-1"
    >
      {children}
      {sort === false ? (
        <ArrowUpDown className="text-blue-600 size-4" />
      ) : sort === "asc" ? (
        <ArrowUp className="text-blue-600 size-4" />
      ) : (
        <ArrowDown className="text-blue-600 size-4" />
      )}
    </Button>
  );
};
